import React, { useState, useEffect, Fragment, useMemo, useRef } from "react";
import {
  Box,
  Button,
  Flex,
  Text,
  useColorModeValue,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  useToast,
  VStack,
  HStack,
  Spinner,
  Select,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Heading,
  Avatar,
  Image,
  Badge,
  IconButton,
  Tooltip,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  FormErrorMessage,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Switch,
} from "@chakra-ui/react";
import {
  SearchIcon,
  AddIcon,
  EditIcon,
  DeleteIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronDownIcon,
} from "@chakra-ui/icons";
import { CheckIcon, CloseIcon } from "@chakra-ui/icons";
import { companiesService, citiesService } from "api";
import { getUserData } from "../../utils/auth";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";

const Companies = () => {
  const [companies, setCompanies] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingPagination, setIsLoadingPagination] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filters, setFilters] = useState({
    user_id: "",
  });
  const [enforcedCompanyId, setEnforcedCompanyId] = useState(null);
  const [pagination, setPagination] = useState({
    current_page: 1,
    per_page: 15,
    total: 0,
    last_page: 1,
  });
     const { isOpen: isModalOpen, onOpen: handleOpenModal, onClose: handleCloseModal } = useDisclosure();
  const { isOpen: isDeleteOpen, onOpen: onDeleteOpen, onClose: onDeleteClose } = useDisclosure();
     const [editingCompany, setEditingCompany] = useState(null);
  const [deletingCompany, setDeletingCompany] = useState(null);
  const [actionLoading, setActionLoading] = useState({
    create: false,
    update: false,
    delete: false,
  });
  const [validationErrors, setValidationErrors] = useState({});
  const [usersDropdown, setUsersDropdown] = useState([]);
  const [isLoadingUsers, setIsLoadingUsers] = useState(false);
  const [userSearchFilter, setUserSearchFilter] = useState("");
  const [branchesCompany, setBranchesCompany] = useState(null);
  const { isOpen: isBranchesOpen, onOpen: onBranchesOpen, onClose: onBranchesClose } = useDisclosure();
  const [branches, setBranches] = useState([]);
  const [isLoadingBranches, setIsLoadingBranches] = useState(false);
  const [cities, setCities] = useState([]);
  const [newBranch, setNewBranch] = useState({
    company_id: '',
    city_id: '',
    title: '',
    address: '',
    latitude: 33.5138,
    longitude: 36.2765,
  });
  const { isOpen: isAddBranchOpen, onOpen: onAddBranchOpen, onClose: onAddBranchClose } = useDisclosure();
  const [editBranch, setEditBranch] = useState(null);
  const { isOpen: isEditBranchOpen, onOpen: onEditBranchOpen, onClose: onEditBranchClose } = useDisclosure();
  const addMapRef = useRef(null);
  const editMapRef = useRef(null);
  const addMarkerRef = useRef(null);
  const editMarkerRef = useRef(null);
     const [formData, setFormData] = useState({
    name: '',
    description: '',
    email: '',
    phone: '',
    user_id: '',
    password: '',
    old_password: '',
    mode: 'light',
    lang: 'en',
    mute_notification: 0,
    logo: null,
    cover: null,
    accepts_points: false,
    is_replaceable: false,
    is_refundable: false
  });
  

  const toast = useToast();
  const textColor = useColorModeValue("gray.700", "white");
  const bgColor = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.600");

              // Fetch companies
  const fetchCompanies = async (page = 1) => {
    setIsLoading(true);
    try {
      // If logged in as a company, fetch profile using /api/company/profile
      try {
        const u = getUserData();
        const isCompany = !!(u && (typeof u.user_id !== 'undefined' || typeof u.logo !== 'undefined'));
        if (isCompany) {
          const resp = await companiesService.getCompanyProfile();
          const data = resp?.data?.data || resp?.data || null;
          const row = data?.data || data; // handle nested
          setCompanies(row ? [row] : []);
          setPagination({ current_page: 1, per_page: 1, total: row ? 1 : 0, last_page: 1 });
          return;
        }
      } catch {}

      const params = {
        page,
        per_page: pagination.per_page,
        ...filters,
      };
      
      if (searchTerm.trim()) {
        params.search = searchTerm.trim();
      }

      console.log('Fetching companies with params:', params);
      const response = await companiesService.getCompanies(params);
      console.log('Companies response:', response);
      
      if (response && response.success && response.data) {
        console.log('Processing response data:', response.data);
        
        // Handle the API response structure: { data: { data: [...], current_page: 1, ... } }
        let companiesData = [];
        let paginationData = {};
        // The API response structure is: response.data.data (nested data)
        if (response.data.data && Array.isArray(response.data.data.data)) {
          // Standard API response structure: response.data.data.data
          companiesData = response.data.data.data;
          console.log('Extracted companies from response.data.data.data:', companiesData);
          paginationData = {
            current_page: response.data.data.current_page || 1,
            per_page: response.data.data.per_page || 15,
            total: response.data.data.total || 0,
            last_page: response.data.data.last_page || 1,
          };
        } else if (response.data.data && Array.isArray(response.data.data)) {
          // Alternative structure: response.data.data
          companiesData = response.data.data;
          console.log('Extracted companies from response.data.data:', companiesData);
          paginationData = {
            current_page: response.data.current_page || 1,
            per_page: response.data.per_page || 15,
            total: response.data.total || 0,
            last_page: response.data.last_page || 1,
          };
        } else if (Array.isArray(response.data)) {
          // Direct array response: response.data
          companiesData = response.data;
          console.log('Extracted companies from direct response.data:', companiesData);
          paginationData = {
            current_page: 1,
            per_page: response.data.length,
            total: response.data.length,
            last_page: 1,
          };
        } else {
          // Fallback: empty array
          companiesData = [];
          paginationData = {
            current_page: 1,
            per_page: 15,
            total: 0,
            last_page: 1,
          };
        }
        
        setCompanies(companiesData);
        setPagination(paginationData);
        
        console.log('Companies data set:', companiesData);
        console.log('Pagination set:', paginationData);
      } else {
        setCompanies([]);
        toast({
          title: "خطأ",
          description: response.message || "حدث خطأ أثناء جلب الشركات",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error in fetchCompanies:", error);
      setCompanies([]);
      toast({
        title: "خطأ",
        description: "حدث خطأ غير متوقع",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
    };



  useEffect(() => {
    // Determine if current auth is a company; if so, enforce its ID
    try {
      const u = getUserData();
      if (u && (typeof u.user_id !== 'undefined' || typeof u.logo !== 'undefined')) {
        setEnforcedCompanyId(u.id);
      }
    } catch {}
    console.log('Companies component mounted, fetching initial data...');
    fetchCompanies();
  }, []);

  // Load branches when opening branches modal
  useEffect(() => {
    const loadBranches = async () => {
      if (!isBranchesOpen || !branchesCompany?.id) return;
      setIsLoadingBranches(true);
      try {
        // load cities for dropdown
        try {
          const c = await citiesService.getCities();
          const cdata = c?.data?.data || c?.data || [];
          setCities(Array.isArray(cdata) ? cdata : []);
        } catch(e) { /* ignore cities error here */ }
        const resp = await companiesService.getCompanyBranches(branchesCompany.id);
        const list = resp?.data?.data?.data || resp?.data?.data || [];
        setBranches(Array.isArray(list) ? list : []);
      } catch (e) {
        console.error('Error loading branches:', e);
        toast({ title: 'خطأ', description: 'تعذر تحميل الفروع', status: 'error', duration: 4000, isClosable: true });
      } finally {
        setIsLoadingBranches(false);
      }
    };
    loadBranches();
  }, [isBranchesOpen, branchesCompany]);

  // Initialize Leaflet map for Add modal (robust)
  useEffect(() => {
    if (!isAddBranchOpen) {
      // Cleanup on close
      if (addMapRef.current) {
        addMapRef.current.remove();
        addMapRef.current = null;
        addMarkerRef.current = null;
      }
      return;
    }

    const ensureLeaflet = async () => {
      if (window.L) return;
      if (!window.__leafletReadyPromise) {
        window.__leafletReadyPromise = new Promise((resolve) => {
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
          document.head.appendChild(link);
          const script = document.createElement('script');
          script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
          script.onload = resolve;
          document.body.appendChild(script);
        });
      }
      await window.__leafletReadyPromise;
    };

    (async () => {
      await ensureLeaflet();
      const LL = window.L;
      // Wait a tick for modal DOM to render
      setTimeout(() => {
        const container = document.getElementById('add-branch-map');
        if (!container) return;
        // If a map was attached previously to this container, remove it
        if (addMapRef.current) {
          addMapRef.current.remove();
          addMapRef.current = null;
          addMarkerRef.current = null;
        }
        addMapRef.current = LL.map(container, { center: [newBranch.latitude, newBranch.longitude], zoom: 14 });
        LL.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { attribution: '&copy; OpenStreetMap' }).addTo(addMapRef.current);
        addMarkerRef.current = LL.marker([newBranch.latitude, newBranch.longitude], { draggable: true }).addTo(addMapRef.current);
        addMarkerRef.current.on('dragend', () => {
          const pos = addMarkerRef.current.getLatLng();
          setNewBranch(prev => ({ ...prev, latitude: pos.lat, longitude: pos.lng }));
        });
        // Fix tiles not showing when modal animates
        setTimeout(() => addMapRef.current && addMapRef.current.invalidateSize(), 200);
      }, 0);
    })();
  }, [isAddBranchOpen, newBranch.latitude, newBranch.longitude]);

  // Initialize Leaflet map for Edit modal (robust)
  useEffect(() => {
    if (!isEditBranchOpen) {
      if (editMapRef.current) {
        editMapRef.current.remove();
        editMapRef.current = null;
        editMarkerRef.current = null;
      }
      return;
    }

    const ensureLeaflet = async () => {
      if (window.L) return;
      if (!window.__leafletReadyPromise) {
        window.__leafletReadyPromise = new Promise((resolve) => {
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
          document.head.appendChild(link);
          const script = document.createElement('script');
          script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
          script.onload = resolve;
          document.body.appendChild(script);
        });
      }
      await window.__leafletReadyPromise;
    };

    (async () => {
      await ensureLeaflet();
      const LL = window.L;
      const lat = editBranch?.latitude || 33.5138;
      const lng = editBranch?.longitude || 36.2765;
      setTimeout(() => {
        const container = document.getElementById('edit-branch-map');
        if (!container) return;
        if (editMapRef.current) {
          editMapRef.current.remove();
          editMapRef.current = null;
          editMarkerRef.current = null;
        }
        editMapRef.current = LL.map(container, { center: [lat, lng], zoom: 14 });
        LL.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { attribution: '&copy; OpenStreetMap' }).addTo(editMapRef.current);
        editMarkerRef.current = LL.marker([lat, lng], { draggable: true }).addTo(editMapRef.current);
        editMarkerRef.current.on('dragend', () => {
          const pos = editMarkerRef.current.getLatLng();
          setEditBranch(prev => ({ ...prev, latitude: pos.lat, longitude: pos.lng }));
        });
        setTimeout(() => editMapRef.current && editMapRef.current.invalidateSize(), 200);
      }, 0);
    })();
  }, [isEditBranchOpen, editBranch?.latitude, editBranch?.longitude]);

            // Debug state changes
  useEffect(() => {
    console.log('Companies state changed:', companies);
  }, [companies]);

  // Handle search and filters
  useEffect(() => {
    console.log('Filters or search term changed, triggering search in 500ms...');
    const timeoutId = setTimeout(() => {
      console.log('Executing search with filters:', filters, 'and search term:', searchTerm);
      fetchCompanies(1);
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [searchTerm, filters]);

  // Handle page change
  const handlePageChange = async (newPage) => {
    if (newPage >= 1 && newPage <= pagination.last_page) {
      setIsLoadingPagination(true);
      try {
        await fetchCompanies(newPage);
      } finally {
        setIsLoadingPagination(false);
      }
    }
  };

  // Fetch users dropdown
  const fetchUsersDropdown = async () => {
    setIsLoadingUsers(true);
    try {
      const response = await companiesService.getUsersDropdown();
      const raw = response?.data?.data || response?.data || [];
      const options = Array.isArray(raw) ? raw : [];
      setUsersDropdown(options);
    } catch (error) {
      console.error('Error fetching users dropdown:', error);
      toast({
        title: "خطأ",
        description: "تعذر تحميل قائمة المستخدمين",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    } finally {
      setIsLoadingUsers(false);
    }
  };

  useEffect(() => {
    fetchUsersDropdown();
  }, []);

  // Front-end search for users
  const filteredUsers = useMemo(() => {
    if (!userSearchFilter.trim()) return usersDropdown;
    const term = userSearchFilter.trim().toLowerCase();
    return usersDropdown.filter(u => `${u.id}`.includes(term) || (u.name || '').toLowerCase().includes(term));
  }, [usersDropdown, userSearchFilter]);

  // Handle search
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

     // Format date - keep in English
   const formatDate = (dateString) => {
     return new Date(dateString).toLocaleDateString('en-US');
   };

       // Handle modal open/close
    const openModal = () => {
      setEditingCompany(null);
      setFormData({
        name: '',
        description: '',
        email: '',
        phone: '',
        user_id: '',
        password: '',
        old_password: '',
        mode: 'light',
        lang: 'en',
        mute_notification: 0,
        logo: null,
        cover: null,
        accepts_points: false,
        is_replaceable: false,
        is_refundable: false
      });
      setValidationErrors({});
      handleOpenModal();
    };

    const closeModal = () => {
      setEditingCompany(null);
      setFormData({
        name: '',
        description: '',
        email: '',
        phone: '',
        user_id: '',
        password: '',
        old_password: '',
        mode: 'light',
        lang: 'en',
        mute_notification: 0,
        logo: null,
        cover: null,
        accepts_points: false,
        is_replaceable: false,
        is_refundable: false
      });
      setValidationErrors({});
      handleCloseModal();
    };

    // Handle edit company
    const handleEdit = (company) => {
      setEditingCompany(company);
      setFormData({
        name: company.name || '',
        description: company.description || '',
        email: company.email || '',
        phone: company.phone || '',
        user_id: company.user_id || '',
        password: '', // Don't populate password for security
        old_password: '', // Don't populate old password for security
        mode: company.mode || 'light',
        lang: company.lang || 'en',
        mute_notification: company.mute_notification || 0,
        logo: company.logo || null, // Store logo URL for preview
        cover: company.cover || null, // Store cover URL for preview
        accepts_points: company.accepts_points || false,
        is_replaceable: company.is_replaceable || false,
        is_refundable: company.is_refundable || false
      });
      setValidationErrors({});
      handleOpenModal();
    };

    // Handle delete company
    const handleDelete = (company) => {
      // Prevent delete for company authentication
      if (enforcedCompanyId) {
        return;
      }
      setDeletingCompany(company);
      onDeleteOpen();
    };

    // Confirm delete company
    const confirmDelete = async () => {
      if (!deletingCompany) return;
      
      // Prevent delete for company authentication
      if (enforcedCompanyId) {
        onDeleteClose();
        return;
      }
      
      setActionLoading(prev => ({ ...prev, delete: true }));
      try {
        const response = await companiesService.deleteCompany(deletingCompany.id);
        if (response && response.success) {
          toast({
            title: "نجح",
            description: "تم حذف الشركة بنجاح",
            status: "success",
            duration: 3000,
            isClosable: true,
          });
          onDeleteClose();
          fetchCompanies(1); // Refresh the list
        } else {
          toast({
            title: "خطأ",
            description: response.message || "حدث خطأ أثناء حذف الشركة",
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        }
      } catch (error) {
        console.error('Error deleting company:', error);
        toast({
          title: "خطأ",
          description: "حدث خطأ غير متوقع أثناء حذف الشركة",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      } finally {
        setActionLoading(prev => ({ ...prev, delete: false }));
      }
    };

   // Handle form input changes
   const handleInputChange = (field, value) => {
     setFormData(prev => ({ ...prev, [field]: value }));
     // Clear validation error for this field
     if (validationErrors[field]) {
       setValidationErrors(prev => ({ ...prev, [field]: '' }));
     }
   };

           // Handle form submission
    const handleSubmit = async () => {
      if (editingCompany) {
        // Update existing company
        setActionLoading(prev => ({ ...prev, update: true }));
      } else {
        // Create new company
        setActionLoading(prev => ({ ...prev, create: true }));
      }
      setValidationErrors({});

      try {
        console.log('Submitting form data:', formData);
        
        let response;
        if (editingCompany) {
          response = await companiesService.updateCompany(editingCompany.id, formData);
          console.log('Update company response:', response);
        } else {
          response = await companiesService.createCompany(formData);
          console.log('Create company response:', response);
        }
        
        if (response && response.success) {
          toast({
            title: "نجح",
            description: editingCompany ? "تم تحديث الشركة بنجاح" : "تم إنشاء الشركة بنجاح",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
          closeModal();
          fetchCompanies(1); // Refresh the list
        } else {
          // Handle case where response.success is false but we still have validation errors
          if (response.status === 422) {
            const validationData = response.data;
            console.log('Response validation error data:', validationData);
            
            if (validationData.data?.error_messages) {
              const errors = {};
              Object.keys(validationData.data.error_messages).forEach(key => {
                errors[key] = validationData.data.error_messages[key][0];
              });
              console.log('Setting validation errors from response:', errors);
              setValidationErrors(errors);
            } else if (validationData.error_messages) {
              const errors = {};
              Object.keys(validationData.error_messages).forEach(key => {
                errors[key] = validationData.error_messages[key][0];
              });
              console.log('Setting validation errors from response (direct):', errors);
              setValidationErrors(errors);
            }
            
            toast({
              title: "خطأ في التحقق",
              description: "يرجى مراجعة البيانات المدخلة",
              status: "error",
              duration: 5000,
              isClosable: true,
            });
          } else {
            toast({
              title: "خطأ",
              description: response.message || (editingCompany ? "حدث خطأ أثناء تحديث الشركة" : "حدث خطأ أثناء إنشاء الشركة"),
              status: "error",
              duration: 5000,
              isClosable: true,
            });
          }
        }
      } catch (error) {
        console.error('Error in handleSubmit:', error);
        
        if (error.response && error.response.status === 422) {
          // Handle validation errors
          const validationData = error.response.data;
          console.log('Validation error data:', validationData);
          
          if (validationData.data?.error_messages) {
            // Handle the structure: { data: { error_messages: {...} } }
            const errors = {};
            Object.keys(validationData.data.error_messages).forEach(key => {
              errors[key] = validationData.data.error_messages[key][0]; // Get first error message
            });
            console.log('Setting validation errors:', errors);
            setValidationErrors(errors);
          } else if (validationData.error_messages) {
            // Handle the structure: { error_messages: {...} }
            const errors = {};
            Object.keys(validationData.error_messages).forEach(key => {
              errors[key] = validationData.error_messages[key][0]; // Get first error message
            });
            console.log('Setting validation errors (direct):', errors);
            setValidationErrors(errors);
          } else if (validationData.errors) {
            // Handle the structure: { errors: {...} }
            const errors = {};
            Object.keys(validationData.errors).forEach(key => {
              errors[key] = validationData.errors[key][0]; // Get first error message
            });
            console.log('Setting validation errors (errors):', errors);
            setValidationErrors(errors);
          }
          
          toast({
            title: "خطأ في التحقق",
            description: "يرجى مراجعة البيانات المدخلة",
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        } else {
          toast({
            title: "خطأ",
            description: "حدث خطأ غير متوقع أثناء " + (editingCompany ? "تحديث" : "إنشاء") + " الشركة",
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        }
      } finally {
        if (editingCompany) {
          setActionLoading(prev => ({ ...prev, update: false }));
        } else {
          setActionLoading(prev => ({ ...prev, create: false }));
        }
      }
    };

     return (
           <Box pt={{ base: "130px", md: "80px", xl: "80px" }} zIndex={1}>
                 <Flex direction="column" w="100%" mb="20px">
        <Card
          maxW="100%"
          w="100%"
          bg={bgColor}
          border="1px solid"
          borderColor={borderColor}
          borderRadius="15px"
          boxShadow="0 4px 20px rgba(0, 0, 0, 0.1)"
        >
                     <CardHeader>
             <Flex direction="column" gap={4}>
               <Heading size="lg" color={textColor}>
                {enforcedCompanyId ? 'الشركة' : 'الشركات'}
               </Heading>
               
                              {/* Search, Filter, and Add Company Row */}
              {!enforcedCompanyId && (
               <Flex gap={3} align="center" flexWrap="nowrap">
                  {/* Search Input */}
                  <InputGroup w="250px" flexShrink={0}>
                    <InputLeftElement pointerEvents="none">
                      <SearchIcon color="gray.400" />
                    </InputLeftElement>
                    <Input
                      placeholder="البحث في الشركات..."
                      value={searchTerm}
                      onChange={handleSearch}
                      borderColor={borderColor}
                      isDisabled={isLoading}
                    />
                    {isLoading && (
                      <InputRightElement>
                        <Spinner size="sm" />
                      </InputRightElement>
                    )}
                  </InputGroup>
                  
                  {/* User Filter (search in dropdown) */}
                  <Flex gap={2} align="center" flexShrink={0}>
                    <Text fontSize="sm" color="gray.600" whiteSpace="nowrap">
                      المستخدم:
                    </Text>
                    <Menu matchWidth>
                      <MenuButton
                        as={Button}
                        rightIcon={<ChevronDownIcon />}
                        variant="outline"
                        borderColor={borderColor}
                        w="260px"
                        isDisabled={isLoadingUsers}
                      >
                        {filters.user_id ? `${filters.user_id} - ${(usersDropdown.find(u => `${u.id}` === `${filters.user_id}`)?.name) || ''}` : (isLoadingUsers ? 'جاري التحميل...' : 'اختر مستخدم')}
                      </MenuButton>
                      <MenuList minW="260px" p={2}>
                        <Input
                          autoFocus
                          placeholder="ابحث بالاسم أو المعرّف"
                          value={userSearchFilter}
                          onChange={(e) => setUserSearchFilter(e.target.value)}
                          borderColor={borderColor}
                          mb={2}
                          autoComplete="off"
                          inputMode="search"
                          spellCheck={false}
                        />
                        <Box maxH="240px" overflowY="auto">
                          {filteredUsers.map(u => (
                            <MenuItem key={u.id} onClick={() => {
                              setFilters(prev => ({ ...prev, user_id: u.id }));
                              setPagination(prev => ({ ...prev, current_page: 1 }));
                              fetchCompanies(1);
                            }}>
                              {u.id} - {u.name}
                            </MenuItem>
                          ))}
                          {filteredUsers.length === 0 && (
                            <Text px={3} py={2} color="gray.500">لا توجد نتائج</Text>
                          )}
                        </Box>
                        {filters.user_id && (
                          <MenuItem onClick={() => {
                            setFilters(prev => ({ ...prev, user_id: "" }));
                            setPagination(prev => ({ ...prev, current_page: 1 }));
                            fetchCompanies(1);
                          }} color="red.500">مسح الاختيار</MenuItem>
                        )}
                      </MenuList>
                    </Menu>
                    {filters.user_id && (
                      <Button size="sm" variant="ghost" onClick={() => setFilters(prev => ({ ...prev, user_id: "" }))}>مسح</Button>
                    )}
                  </Flex>
                  
                                     {/* Add Company Button */}
                   <Button
                     leftIcon={<AddIcon />}
                     colorScheme="blue"
                     size="md"
                     borderRadius="8px"
                     flexShrink={0}
                     onClick={openModal}
                   >
                     إضافة شركة جديدة
                   </Button>
                  
                  {/* Clear Search Button */}
                  {searchTerm && (
                    <Button
                      size="md"
                      variant="outline"
                      onClick={() => setSearchTerm("")}
                      colorScheme="gray"
                      flexShrink={0}
                    >
                      مسح البحث
                    </Button>
                  )}
                </Flex>
              )}
             </Flex>
           </CardHeader>

                     <CardBody>

            
                         {/* Per Page Selector and Refresh */}
            {!enforcedCompanyId && (
            <Flex justify="space-between" align="center" mb={4}>
               <Flex align="center" gap={3} p={2}>
                 <Text fontSize="sm" color="gray.600">
                   عرض
                 </Text>
                 <Select
                   value={pagination.per_page}
                   onChange={(e) => {
                     const newPerPage = parseInt(e.target.value);
                     setPagination(prev => ({ ...prev, per_page: newPerPage, current_page: 1 }));
                     fetchCompanies(1);
                   }}
                   w="80px"
                   size="sm"
                   mx={2}
                 >
                   <option value={15}>15</option>
                   <option value={25}>25</option>
                   <option value={50}>50</option>
                   <option value={100}>100</option>
                 </Select>
                 <Text fontSize="sm" color="gray.600">
                   شركة في الصفحة
                 </Text>
               </Flex>
              
              <HStack spacing={2}>
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => {
                    setFilters({ user_id: "" });
                    setSearchTerm("");
                    setPagination(prev => ({ ...prev, current_page: 1 }));
                    fetchCompanies(1);
                  }}
                  colorScheme="gray"
                >
                  مسح الفلاتر
                </Button>
                
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => fetchCompanies(pagination.current_page)}
                  leftIcon={<SearchIcon />}
                  isLoading={isLoading}
                >
                  تحديث
                </Button>
              </HStack>
            </Flex>
            )}

            {/* Results Summary and Active Filters */}
            <Flex justify="space-between" align="center" mb={4} p={3} bg="white" borderRadius="md">
              <VStack align="start" spacing={1}>
                {isLoading ? (
                  <Flex align="center" gap={2}>
                    <Spinner size="sm" />
                    <Text fontSize="sm" color="gray.600">جاري التحميل...</Text>
                  </Flex>
                ) : (
                  <Text fontSize="sm">
                  </Text>
                )}
                

              </VStack>
              
              {!enforcedCompanyId && (
                <Text fontSize="sm" color="gray.600">
                  صفحة {pagination.current_page} من {pagination.last_page}
                </Text>
              )}
            </Flex>

            {/* Companies Table */}
            {isLoading ? (
              <Flex direction="column" justify="center" align="center" p={8} gap={4}>
                <Spinner size="lg" color="blue.500" />
                <Text color="gray.600">جاري تحميل الشركات...</Text>
                
                {/* Skeleton Table */}
                <Box w="100%" mt={4}>
                  <TableContainer>
                    <Table variant="simple">
                      <Thead>
                        <Tr>
                          <Th>الشركة</Th>
                          <Th>المستخدم</Th>
                          <Th>معلومات الاتصال</Th>
                          <Th>تاريخ الإنشاء</Th>
                          <Th>الإجراءات</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {Array.from({ length: 5 }, (_, i) => (
                          <Tr key={i}>
                            <Td>
                              <Flex align="center" gap={3}>
                                <Box w="32px" h="32px" bg="gray.200" borderRadius="full" />
                                <Box w="120px" h="20px" bg="gray.200" borderRadius="md" />
                              </Flex>
                            </Td>
                            <Td>
                              <Flex align="center" gap={2}>
                                <Box w="24px" h="24px" bg="gray.200" borderRadius="full" />
                                <Box w="100px" h="20px" bg="gray.200" borderRadius="md" />
                              </Flex>
                            </Td>
                            <Td><Box w="150px" h="20px" bg="gray.200" borderRadius="md" /></Td>
                            <Td><Box w="100px" h="20px" bg="gray.200" borderRadius="md" /></Td>
                            <Td>
                              <Flex gap={2}>
                                <Box w="32px" h="32px" bg="gray.200" borderRadius="md" />
                                <Box w="32px" h="32px" bg="gray.200" borderRadius="md" />
                              </Flex>
                            </Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                  </TableContainer>
                </Box>
              </Flex>
            ) : companies.length === 0 ? (
              <Flex justify="center" align="center" p={8} direction="column" gap={4}>
                <Box textAlign="center">
                  <Text color="gray.500" fontSize="xl" mb={2}>
                    {searchTerm || filters.user_id
                      ? "لا توجد نتائج تطابق الفلاتر المحددة" 
                      : "لا توجد شركات متاحة"}
                  </Text>
                  <Text color="gray.400" fontSize="sm">
                    {searchTerm || filters.user_id 
                      ? "جرب تغيير الفلاتر أو البحث عن شيء آخر"
                      : "لم يتم العثور على شركات في النظام"}
                  </Text>
                </Box>
                
                {(searchTerm || filters.user_id) && (
                  <Button
                    size="md"
                    variant="outline"
                    onClick={() => {
                      setFilters({ user_id: "" });
                      setSearchTerm("");
                      setPagination(prev => ({ ...prev, current_page: 1 }));
                      fetchCompanies(1);
                    }}
                    colorScheme="blue"
                    leftIcon={<SearchIcon />}
                  >
                    مسح جميع الفلاتر
                  </Button>
                )}
              </Flex>
            ) : (
              <TableContainer>
                <Table variant="simple">
                  <Thead>
                    <Tr>
                      <Th color={textColor} fontSize="md" fontWeight="bold">الشركة</Th>
                      <Th color={textColor} fontSize="md" fontWeight="bold">المستخدم</Th>
                      <Th color={textColor} fontSize="md" fontWeight="bold">معلومات الاتصال</Th>
                      <Th color={textColor} fontSize="md" fontWeight="bold">تاريخ الإنشاء</Th>
                      <Th color={textColor} fontSize="md" fontWeight="bold">الإجراءات</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {Array.isArray(companies) && companies.length > 0 ? (
                      companies.map((company) => (
                        <Tr key={company.id}>
                          <Td>
                            <Flex align="center" gap={3}>
                                                             <Avatar
                                 size="md"
                                 src={company.logo}
                                 name={company.name}
                                 borderRadius="full"
                                 objectFit="cover"
                               />
                              <Box>
                                <Text fontWeight="bold" color={textColor}>
                                  {company.name}
                                </Text>
                                {company.description && (
                                  <Text fontSize="sm" color="gray.600" noOfLines={2}>
                                    {company.description}
                                  </Text>
                                )}
                              </Box>
                            </Flex>
                          </Td>
                          <Td>
                            <Flex align="center" gap={2}>
                                                             <Avatar
                                 size="sm"
                                 src={company.user?.profile_photo}
                                 name={company.user?.name}
                                 objectFit="cover"
                               />
                              <Text fontWeight="medium" color={textColor}>
                                {company.user?.name}
                              </Text>
                            </Flex>
                          </Td>
                          <Td>
                            <VStack align="start" spacing={1}>
                              <Text fontSize="sm" color="gray.600">
                                {company.email}
                              </Text>
                              {company.phone && (
                                <Text fontSize="sm" color="gray.600">
                                  {company.phone}
                                </Text>
                              )}
                            </VStack>
                          </Td>
                          <Td>
                            <Text color="gray.600" fontSize="sm">
                              {formatDate(company.created_at)}
                            </Text>
                          </Td>
                          <Td>
                            <HStack spacing={2}>
                                                             <Tooltip label="تعديل">
                                 <IconButton
                                   icon={<EditIcon />}
                                   size="sm"
                                   colorScheme="blue"
                                   variant="ghost"
                                   onClick={(e) => {
                                     e.stopPropagation();
                                     handleEdit(company);
                                   }}
                                 />
                               </Tooltip>
                                <Tooltip label="الفروع">
                                  <IconButton
                                    icon={<SearchIcon />}
                                    size="sm"
                                    colorScheme="teal"
                                    variant="ghost"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setBranchesCompany(company);
                                      onBranchesOpen();
                                    }}
                                  />
                                </Tooltip>
                                                             {/* Delete button - hidden for company auth */}
                                 {!enforcedCompanyId && (
                                   <Tooltip label="حذف">
                                     <IconButton
                                       icon={<DeleteIcon />}
                                       size="sm"
                                       colorScheme="red"
                                       variant="ghost"
                                       onClick={(e) => {
                                         e.stopPropagation();
                                         handleDelete(company);
                                       }}
                                     />
                                   </Tooltip>
                                 )}
                            </HStack>
                          </Td>
                        </Tr>
                      ))
                    ) : (
                      <Tr>
                        <Td colSpan={5}>
                          <Flex justify="center" align="center" py={8}>
                            <Text color="gray.500">
                              {searchTerm || filters.user_id ? "لا توجد نتائج تطابق الفلاتر المحددة" : "لا توجد شركات متاحة"}
                            </Text>
                          </Flex>
                        </Td>
                      </Tr>
                    )}
                  </Tbody>
                </Table>
              </TableContainer>
            )}

            {/* Pagination Controls */}
            {!enforcedCompanyId && Array.isArray(companies) && companies.length > 0 && (
              <Flex justify="center" align="center" mt={6} gap={2} flexWrap="wrap">
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => handlePageChange(1)}
                  isDisabled={pagination.current_page <= 1 || isLoadingPagination}
                  isLoading={isLoadingPagination && pagination.current_page === 1}
                >
                  الأولى
                </Button>
                
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => handlePageChange(pagination.current_page - 1)}
                  isDisabled={pagination.current_page <= 1 || isLoadingPagination}
                  leftIcon={<ChevronLeftIcon />}
                  isLoading={isLoadingPagination}
                >
                  السابق
                </Button>
                
                {/* Page Numbers */}
                {Array.from({ length: Math.min(5, pagination.last_page) }, (_, i) => {
                  let pageNum;
                  if (pagination.last_page <= 5) {
                    pageNum = i + 1;
                  } else if (pagination.current_page <= 3) {
                    pageNum = i + 1;
                  } else if (pagination.current_page >= pagination.last_page - 2) {
                    pageNum = pagination.last_page - 4 + i;
                  } else {
                    pageNum = pagination.current_page - 2 + i;
                  }
                  
                  if (pageNum < 1 || pageNum > pagination.last_page) return null;
                  
                  return (
                    <Button
                      key={pageNum}
                      size="sm"
                      variant={pagination.current_page === pageNum ? "solid" : "outline"}
                      colorScheme={pagination.current_page === pageNum ? "blue" : "gray"}
                      onClick={() => handlePageChange(pageNum)}
                      isLoading={isLoadingPagination}
                      isDisabled={isLoadingPagination}
                    >
                      {pageNum}
                    </Button>
                  );
                })}
                
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => handlePageChange(pagination.current_page + 1)}
                  isDisabled={pagination.current_page >= pagination.last_page || isLoadingPagination}
                  rightIcon={<ChevronRightIcon />}
                  isLoading={isLoadingPagination}
                >
                  التالي
                </Button>
                
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => handlePageChange(pagination.last_page)}
                  isDisabled={pagination.current_page >= pagination.last_page || isLoadingPagination}
                  isLoading={isLoadingPagination && pagination.current_page === pagination.last_page}
                >
                  الأخيرة
                </Button>
                
                <Text fontSize="sm" color="gray.600" ml={4}>
                  إجمالي {pagination.total} شركة
                </Text>
                
                {/* Go to Page Input */}
                <HStack spacing={2} ml={4}>
                  <Text fontSize="sm" color="gray.600">اذهب إلى:</Text>
                  <Input
                    size="sm"
                    w="60px"
                    type="number"
                    min={1}
                    max={pagination.last_page}
                    value={pagination.current_page}
                    onChange={(e) => {
                      const page = parseInt(e.target.value);
                      if (page >= 1 && page <= pagination.last_page) {
                        setPagination(prev => ({ ...prev, current_page: page }));
                      }
                    }}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        const page = parseInt(e.target.value);
                        if (page >= 1 && page <= pagination.last_page) {
                          handlePageChange(page);
                        }
                      }
                    }}
                  />
                  <Text fontSize="sm" color="gray.600">من {pagination.last_page}</Text>
                </HStack>
              </Flex>
            )}
                     </CardBody>
         </Card>
       </Flex>

               {/* Create Company Modal */}
        <Modal isOpen={isModalOpen} onClose={closeModal} size="xl" closeOnOverlayClick={true}>
          <ModalOverlay zIndex={1400} />
          <ModalContent 
            zIndex={1401} 
            mx={4} 
            my={8}
            mb="20px"
            sx={{
              marginTop: '120px !important',
              marginBottom: '20px !important'
            }}
          >
           <ModalHeader>{editingCompany ? `تعديل الشركة: ${editingCompany.name}` : 'إضافة شركة جديدة'}</ModalHeader>
           <ModalCloseButton />
           <ModalBody pb={6}>
             <VStack spacing={4}>
               {/* Company Name */}
               <FormControl isInvalid={!!validationErrors.name}>
                 <FormLabel>اسم الشركة</FormLabel>
                 <Input
                   placeholder="أدخل اسم الشركة"
                   value={formData.name}
                   onChange={(e) => handleInputChange('name', e.target.value)}
                   borderColor={borderColor}
                 />
                 <FormErrorMessage>{validationErrors.name}</FormErrorMessage>
               </FormControl>

               {/* Description */}
               <FormControl isInvalid={!!validationErrors.description}>
                 <FormLabel>الوصف</FormLabel>
                 <Input
                   placeholder="أدخل وصف الشركة"
                   value={formData.description}
                   onChange={(e) => handleInputChange('description', e.target.value)}
                   borderColor={borderColor}
                 />
                 <FormErrorMessage>{validationErrors.description}</FormErrorMessage>
               </FormControl>

               {/* Email */}
               <FormControl isInvalid={!!validationErrors.email}>
                 <FormLabel>البريد الإلكتروني</FormLabel>
                 <Input
                   type="email"
                   placeholder="أدخل البريد الإلكتروني"
                   value={formData.email}
                   onChange={(e) => handleInputChange('email', e.target.value)}
                   borderColor={borderColor}
                 />
                 <FormErrorMessage>{validationErrors.email}</FormErrorMessage>
               </FormControl>

               {/* Phone */}
               <FormControl isInvalid={!!validationErrors.phone}>
                 <FormLabel>رقم الهاتف</FormLabel>
                 <Input
                   placeholder="أدخل رقم الهاتف"
                   value={formData.phone}
                   onChange={(e) => handleInputChange('phone', e.target.value)}
                   borderColor={borderColor}
                 />
                 <FormErrorMessage>{validationErrors.phone}</FormErrorMessage>
               </FormControl>

               {/* User (searchable select) - hidden for company auth */}
               {!enforcedCompanyId && (
                 <FormControl isInvalid={!!validationErrors.user_id}>
                   <FormLabel>المستخدم</FormLabel>
                   <Input
                     placeholder="ابحث بالاسم أو المعرّف"
                     value={userSearchFilter}
                     onChange={(e) => setUserSearchFilter(e.target.value)}
                     borderColor={borderColor}
                     mb={2}
                   />
                   <Select
                     placeholder={isLoadingUsers ? 'جاري التحميل...' : 'اختر مستخدم'}
                     value={formData.user_id}
                     onChange={(e) => handleInputChange('user_id', e.target.value)}
                     borderColor={borderColor}
                     isDisabled={isLoadingUsers}
                   >
                     {filteredUsers.map(u => (
                       <option key={u.id} value={u.id}>{u.id} - {u.name}</option>
                     ))}
                   </Select>
                   <FormErrorMessage>{validationErrors.user_id}</FormErrorMessage>
                 </FormControl>
               )}

               {/* Password */}
               <FormControl isInvalid={!!validationErrors.password}>
                 <FormLabel>كلمة المرور</FormLabel>
                 <Input
                   type="password"
                   placeholder="أدخل كلمة المرور"
                   value={formData.password}
                   onChange={(e) => handleInputChange('password', e.target.value)}
                   borderColor={borderColor}
                 />
                 <FormErrorMessage>{validationErrors.password}</FormErrorMessage>
               </FormControl>

               {/* Old Password - only for company auth */}
               {enforcedCompanyId && (
                 <FormControl isInvalid={!!validationErrors.old_password}>
                   <FormLabel>كلمة المرور القديمة</FormLabel>
                   <Input
                     type="password"
                     placeholder="أدخل كلمة المرور القديمة"
                     value={formData.old_password}
                     onChange={(e) => handleInputChange('old_password', e.target.value)}
                     borderColor={borderColor}
                   />
                   <FormErrorMessage>{validationErrors.old_password}</FormErrorMessage>
                 </FormControl>
               )}

               {/* Mode */}
               <FormControl isInvalid={!!validationErrors.mode}>
                 <FormLabel>الوضع</FormLabel>
                 <Select
                   value={formData.mode}
                   onChange={(e) => handleInputChange('mode', e.target.value)}
                   borderColor={borderColor}
                 >
                   <option value="light">فاتح</option>
                   <option value="dark">داكن</option>
                 </Select>
                 <FormErrorMessage>{validationErrors.mode}</FormErrorMessage>
               </FormControl>

               {/* Language */}
               <FormControl isInvalid={!!validationErrors.lang}>
                 <FormLabel>اللغة</FormLabel>
                 <Select
                   value={formData.lang}
                   onChange={(e) => handleInputChange('lang', e.target.value)}
                   borderColor={borderColor}
                 >
                   <option value="en">English</option>
                   <option value="ar">العربية</option>
                 </Select>
                 <FormErrorMessage>{validationErrors.lang}</FormErrorMessage>
               </FormControl>

               {/* Mute Notifications */}
               <FormControl isInvalid={!!validationErrors.mute_notification}>
                 <FormLabel>كتم الإشعارات</FormLabel>
                 <Select
                   value={formData.mute_notification}
                   onChange={(e) => handleInputChange('mute_notification', parseInt(e.target.value))}
                   borderColor={borderColor}
                 >
                   <option value={0}>تفعيل الإشعارات</option>
                   <option value={1}>كتم الإشعارات</option>
                 </Select>
                 <FormErrorMessage>{validationErrors.mute_notification}</FormErrorMessage>
               </FormControl>

               {/* Logo Upload */}
               <FormControl isInvalid={!!validationErrors.logo}>
                 <FormLabel>الشعار</FormLabel>
                 {/* Show current logo if editing and logo is a URL */}
                 {editingCompany && formData.logo && typeof formData.logo === 'string' && (
                  <Box mb={2}>
                    <Text fontSize="sm" color="gray.500" mb={1}>الصورة الحالية:</Text>
                    <Image 
                      src={formData.logo} 
                      alt="Current logo" 
                      maxH="150px" 
                      maxW="150px" 
                      objectFit="contain"
                      borderRadius="md"
                      border="1px solid"
                      borderColor={borderColor}
                      p={2}
                    />
                  </Box>
                )}
                <Input
                  type="file"
                  accept="image/*"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      handleInputChange('logo', file);
                    }
                  }}
                  borderColor={borderColor}
                />
                <FormErrorMessage>{validationErrors.logo}</FormErrorMessage>
              </FormControl>

              {/* Cover Upload */}
              <FormControl isInvalid={!!validationErrors.cover}>
                <FormLabel>صورة الغلاف</FormLabel>
                {/* Show current cover if editing and cover is a URL */}
                {editingCompany && formData.cover && typeof formData.cover === 'string' && (
                  <Box mb={2}>
                    <Text fontSize="sm" color="gray.500" mb={1}>الصورة الحالية:</Text>
                    <Image 
                      src={formData.cover} 
                      alt="Current cover" 
                      maxH="150px" 
                      maxW="300px" 
                      objectFit="contain"
                      borderRadius="md"
                      border="1px solid"
                      borderColor={borderColor}
                      p={2}
                    />
                  </Box>
                )}
                <Input
                  type="file"
                  accept="image/*"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      handleInputChange('cover', file);
                    }
                  }}
                  borderColor={borderColor}
                />
                <FormErrorMessage>{validationErrors.cover}</FormErrorMessage>
              </FormControl>

              {/* Accepts Points Toggle */}
              <FormControl display="flex" alignItems="center" gap={3}>
                <FormLabel m={0}>يقبل النقاط</FormLabel>
                <Switch 
                  isChecked={!!formData.accepts_points} 
                  onChange={(e) => handleInputChange('accepts_points', e.target.checked)} 
                />
              </FormControl>

              {/* Is Replaceable Toggle */}
              <FormControl display="flex" alignItems="center" gap={3}>
                <FormLabel m={0}>قابل للاستبدال</FormLabel>
                <Switch 
                  isChecked={!!formData.is_replaceable} 
                  onChange={(e) => handleInputChange('is_replaceable', e.target.checked)} 
                />
              </FormControl>

              {/* Is Refundable Toggle */}
              <FormControl display="flex" alignItems="center" gap={3}>
                <FormLabel m={0}>قابل للاسترجاع</FormLabel>
                <Switch 
                  isChecked={!!formData.is_refundable} 
                  onChange={(e) => handleInputChange('is_refundable', e.target.checked)} 
                />
              </FormControl>
             </VStack>
           </ModalBody>

                       <ModalFooter>
              <Button
                colorScheme="blue"
                mr={3}
                onClick={handleSubmit}
                isLoading={actionLoading.create || actionLoading.update}
                loadingText={editingCompany ? "جاري التحديث..." : "جاري الإنشاء..."}
                size="lg"
                px={8}
                py={3}
                borderRadius="lg"
                fontWeight="semibold"
                _hover={{
                  transform: "translateY(-2px)",
                  boxShadow: "lg"
                }}
                transition="all 0.2s"
              >
                {editingCompany ? "تحديث الشركة" : "إنشاء الشركة"}
              </Button>
            </ModalFooter>
                   </ModalContent>
        </Modal>

        {/* Edit Branch Modal */}
        <Modal isOpen={isEditBranchOpen} onClose={onEditBranchClose} size="4xl" isCentered>
          <ModalOverlay />
          <ModalContent mx={4} my={8} borderRadius="15px" border="1px solid" borderColor={borderColor} boxShadow="0 12px 32px rgba(0,0,0,0.2)">
            <ModalHeader>تعديل الفرع</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Flex gap={3} wrap="wrap" mb={3}>
                <FormControl w={{ base: "100%", md: "220px" }}>
                  <FormLabel>عنوان الفرع</FormLabel>
                  <Input value={editBranch?.title || ''} onChange={(e) => setEditBranch(prev => ({ ...prev, title: e.target.value }))} />
                </FormControl>
                <FormControl w={{ base: "100%", md: "220px" }}>
                  <FormLabel>المدينة</FormLabel>
                  <Select value={editBranch?.city_id || ''} onChange={(e) => setEditBranch(prev => ({ ...prev, city_id: e.target.value }))}>
                    {cities.map(ct => (
                      <option key={ct.id} value={ct.id}>{ct.id} - {(ct.name || ct.ar_name || ct.en_name)}</option>
                    ))}
                  </Select>
                </FormControl>
                <FormControl flex={1} minW={{ base: "100%", md: "280px" }}>
                  <FormLabel>العنوان التفصيلي</FormLabel>
                  <Input value={editBranch?.address || ''} onChange={(e) => setEditBranch(prev => ({ ...prev, address: e.target.value }))} />
                </FormControl>
              </Flex>
              <Box position="relative" borderRadius="12px" overflow="hidden" border="1px solid" borderColor={borderColor} mb={3}>
                <Box id="edit-branch-map" width="100%" height="280" />
              </Box>
            </ModalBody>
            <ModalFooter>
              <HStack>
                <Button leftIcon={<CheckIcon />} colorScheme="green" onClick={async () => {
                  const payload = {
                    company_id: editBranch?.company_id || branchesCompany?.id,
                    city_id: editBranch?.city_id,
                    title: editBranch?.title,
                    address: editBranch?.address,
                    longitude: editBranch?.longitude,
                    latitude: editBranch?.latitude,
                  };
                  try {
                    await companiesService.updateCompanyBranch(editBranch?.id, payload);
                    const resp = await companiesService.getCompanyBranches(branchesCompany.id);
                    const list = resp?.data?.data?.data || resp?.data?.data || [];
                    setBranches(Array.isArray(list) ? list : []);
                    onEditBranchClose();
                    toast({ title: 'نجح', description: 'تم حفظ التعديلات', status: 'success', duration: 3000, isClosable: true });
                  } catch (e) {
                    console.error(e);
                    toast({ title: 'خطأ', description: 'تعذر حفظ التعديلات', status: 'error', duration: 4000, isClosable: true });
                  }
                }}>حفظ</Button>
                <Button leftIcon={<CloseIcon />} variant="outline" onClick={onEditBranchClose}>إلغاء</Button>
              </HStack>
            </ModalFooter>
          </ModalContent>
        </Modal>
        {/* Add Branch Modal */}
        <Modal isOpen={isAddBranchOpen} onClose={onAddBranchClose} size="4xl" isCentered>
          <ModalOverlay />
          <ModalContent mx={4} my={8} borderRadius="15px" border="1px solid" borderColor={borderColor} boxShadow="0 12px 32px rgba(0,0,0,0.2)">
            <ModalHeader>إضافة فرع جديد</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Flex gap={3} wrap="wrap" mb={3}>
                <FormControl w={{ base: "100%", md: "220px" }}>
                  <FormLabel>عنوان الفرع</FormLabel>
                  <Input value={newBranch.title} onChange={(e) => setNewBranch(prev => ({ ...prev, title: e.target.value }))} />
                </FormControl>
                <FormControl w={{ base: "100%", md: "220px" }}>
                  <FormLabel>المدينة</FormLabel>
                  <Select value={newBranch.city_id} placeholder="اختر المدينة" onChange={(e) => setNewBranch(prev => ({ ...prev, city_id: e.target.value }))}>
                    {cities.map(ct => (
                      <option key={ct.id} value={ct.id}>{ct.id} - {(ct.name || ct.ar_name || ct.en_name)}</option>
                    ))}
                  </Select>
                </FormControl>
                <FormControl flex={1} minW={{ base: "100%", md: "280px" }}>
                  <FormLabel>العنوان التفصيلي</FormLabel>
                  <Input value={newBranch.address} onChange={(e) => setNewBranch(prev => ({ ...prev, address: e.target.value }))} />
                </FormControl>
              </Flex>
              <Box position="relative" borderRadius="12px" overflow="hidden" border="1px solid" borderColor={borderColor} mb={3}>
                <Box id="add-branch-map" width="100%" height="280" />
              </Box>
            </ModalBody>
            <ModalFooter>
              <HStack>
                <Button leftIcon={<CheckIcon />} colorScheme="green" onClick={async () => {
                  const payload = {
                    company_id: branchesCompany?.id,
                    city_id: newBranch.city_id,
                    title: newBranch.title,
                    address: newBranch.address,
                    longitude: newBranch.longitude,
                    latitude: newBranch.latitude,
                  };
                  try {
                    await companiesService.createCompanyBranch(payload);
                    const resp = await companiesService.getCompanyBranches(branchesCompany.id);
                    const list = resp?.data?.data?.data || resp?.data?.data || [];
                    setBranches(Array.isArray(list) ? list : []);
                    onAddBranchClose();
                    toast({ title: 'نجح', description: 'تم إنشاء الفرع', status: 'success', duration: 3000, isClosable: true });
                  } catch (e) {
                    console.error(e);
                    toast({ title: 'خطأ', description: 'تعذر إنشاء الفرع', status: 'error', duration: 4000, isClosable: true });
                  }
                }}>حفظ</Button>
                <Button leftIcon={<CloseIcon />} variant="outline" onClick={onAddBranchClose}>إلغاء</Button>
              </HStack>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* Branches Modal */}
        <Modal isOpen={isBranchesOpen} onClose={() => { setBranchesCompany(null); onBranchesClose(); }} size="4xl" isCentered>
          <ModalOverlay />
          <ModalContent mx={4} my={8} borderRadius="15px" border="1px solid" borderColor={borderColor} boxShadow="0 12px 32px rgba(0,0,0,0.2)">
            <ModalHeader>فروع شركة {branchesCompany?.name ? `- ${branchesCompany.name}` : ''}</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Flex justify="space-between" align="center" mb={4}>
                <Text color="gray.600">إجمالي {branches.length} فرع</Text>
                <Button leftIcon={<AddIcon />} colorScheme="blue" size="sm" borderRadius="8px" onClick={() => {
                  setNewBranch({
                    company_id: branchesCompany?.id || '',
                    city_id: '',
                    title: '',
                    address: '',
                    latitude: 33.5138,
                    longitude: 36.2765,
                  });
                  onAddBranchOpen();
                }}>إضافة فرع</Button>
              </Flex>


              {isLoadingBranches ? (
                <Flex align="center" justify="center" py={10} gap={3}>
                  <Spinner />
                  <Text>جاري تحميل الفروع...</Text>
                </Flex>
              ) : (
                <TableContainer>
                  <Table size="sm">
                    <Thead>
                      <Tr>
                        <Th>العنوان</Th>
                        <Th>الشركة</Th>
                        <Th>العنوان التفصيلي</Th>
                        <Th>المدينة</Th>
                        <Th>خط العرض</Th>
                        <Th>خط الطول</Th>
                        <Th>الإجراءات</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {branches.map((b, idx) => (
                        <Fragment key={(b.id ?? 'new') + '-' + idx}>
                          <Tr>
                            <Td>
                              <Text>{b.title}</Text>
                            </Td>
                            <Td>
                              <Text>{b.company?.name || branchesCompany?.name || b.company_id}</Text>
                            </Td>
                            <Td>
                              <Text>{b.address}</Text>
                            </Td>
                            <Td>
                              <Text>{b.city?.name || b.city_id}</Text>
                            </Td>
                            <Td>
                              <Text>{b.latitude}</Text>
                            </Td>
                            <Td>
                              <Text>{b.longitude}</Text>
                            </Td>
                            <Td>
                              <HStack spacing={2}>
                                {b.isEditing ? (
                                  <Text fontSize="sm" color="gray.500">وضع التعديل</Text>
                                ) : (
                                  <>
                                    <Tooltip label="تعديل">
                                      <IconButton icon={<EditIcon />} size="sm" colorScheme="blue" variant="ghost" onClick={() => {
                                        setEditBranch({
                                          id: b.id,
                                          company_id: b.company_id || branchesCompany?.id || '',
                                          city_id: b.city_id || '',
                                          title: b.title || '',
                                          address: b.address || '',
                                          latitude: b.latitude || 33.5138,
                                          longitude: b.longitude || 36.2765,
                                        });
                                        onEditBranchOpen();
                                      }} />
                                    </Tooltip>
                                    <Tooltip label="حذف">
                                      <IconButton icon={<DeleteIcon />} size="sm" colorScheme="red" variant="ghost" onClick={async () => {
                                        if (!b.id) {
                                          setBranches(prev => prev.filter((_,i) => i!==idx));
                                          return;
                                        }
                                        try {
                                          await companiesService.deleteCompanyBranch(b.id);
                                          setBranches(prev => prev.filter((_,i) => i!==idx));
                                          toast({ title: 'نجح', description: 'تم حذف الفرع', status: 'success', duration: 3000, isClosable: true });
                                        } catch (e) {
                                          console.error(e);
                                          toast({ title: 'خطأ', description: 'تعذر حذف الفرع', status: 'error', duration: 4000, isClosable: true });
                                        }
                                      }} />
                                    </Tooltip>
                                  </>
                                )}
                              </HStack>
                            </Td>
                          </Tr>
                          {/* No inline edit form; edit uses separate modal */}
                        </Fragment>
                      ))}
                      {branches.length === 0 && (
                        <Tr>
                          <Td colSpan={6}>
                            <Text textAlign="center" color="gray.500">لا توجد فروع</Text>
                          </Td>
                        </Tr>
                      )}
                    </Tbody>
                  </Table>
                </TableContainer>
              )}
            </ModalBody>
            <ModalFooter>
              <Button variant="ghost" onClick={() => { setBranchesCompany(null); onBranchesClose(); }}>إغلاق</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* Delete Confirmation Dialog */}
        <AlertDialog isOpen={isDeleteOpen} onClose={onDeleteClose} isCentered>
          <AlertDialogOverlay bg="blackAlpha.300" backdropFilter="blur(10px)">
            <AlertDialogContent
              mx="20px"
              maxW="500px"
              zIndex={9999}
              position="relative"
              borderRadius="15px"
              boxShadow="0 20px 60px rgba(0, 0, 0, 0.3)"
              border="1px solid"
              borderColor="gray.200"
            >
              <AlertDialogHeader
                fontSize="xl"
                fontWeight="bold"
                textAlign="center"
                borderBottom="1px solid"
                borderColor="gray.200"
                pb="20px"
              >
                حذف الشركة
              </AlertDialogHeader>
              <AlertDialogBody
                pt="20px"
                pb="20px"
                textAlign="center"
                fontSize="md"
                color="gray.600"
              >
                هل أنت متأكد من حذف الشركة <strong>"{deletingCompany?.name}"</strong>؟ لا يمكن التراجع عن هذا الإجراء.
              </AlertDialogBody>
              <AlertDialogFooter
                borderTop="1px solid"
                borderColor="gray.200"
                pt="20px"
                gap="15px"
              >
                <Button
                  onClick={onDeleteClose}
                  size="lg"
                  minW="120px"
                  borderRadius="8px"
                  variant="outline"
                  border="2px solid"
                  borderColor="gray.300"
                  _hover={{ bg: "gray.50", borderColor: "gray.400" }}
                >
                  إلغاء
                </Button>
                <Button
                  colorScheme="red"
                  onClick={confirmDelete}
                  size="lg"
                  minW="120px"
                  borderRadius="8px"
                  isLoading={actionLoading.delete}
                  loadingText="جاري الحذف..."
                  _hover={{ transform: "translateY(-1px)", boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)" }}
                >
                  حذف
                </Button>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>
      </Box>
    );
  };

export default Companies;
